import {names} from "../cody-wizard/node/names";

export const playFQCNFromDefinitionId = (definitionId: string): string => {
  const withoutPrefix = definitionId.replace('/definitions/', '');

  const fqcnParts = withoutPrefix.split("/");

  return fqcnParts.map(p => names(p).className).join(".");
}

export const playDefinitionIdFromFQCN = (fqcn: string): string => {
  return '/definitions/' + fqcn
    .split(".")
    .map(r => names(r).fileName)
    .join("/");
}
